<template>
  <el-table-column
    prop="deadline"
    sortable="custom"
    label="Határidő"
    show-overflow-tooltip
    width="160px"
  >
    <template slot-scope="scope">
      <div v-if="isExpired(scope.row)" class="expired">{{ scope.row.deadline | dateTime }}</div>
      <el-tag v-if="isExpired(scope.row)" size="mini" type="danger">Lejárt határidő</el-tag>
      <div v-if="isExpireSoon(scope.row) && !isExpired(scope.row)" class="expire-soon">{{ scope.row.deadline | dateTime }}</div>
      <el-tag v-if="isExpireSoon(scope.row) && !isExpired(scope.row)" size="mini" type="warning">Hamarosan határidő</el-tag>
      <div v-if="!isExpired(scope.row) && !isExpireSoon(scope.row)">{{ scope.row.deadline | dateTime }}</div>
    </template>
  </el-table-column>
</template>

<script>
import moment from 'moment';

export default {
  propName: 'deadline',
  methods: {
    isExpired(row) {
      return moment().isAfter(moment(row.deadline)) && row.status !== 'done';
    },
    isExpireSoon(row) {
      return moment().add(1, 'day').isAfter(moment(row.deadline)) && row.status !== 'done';
    },
  },
};
</script>

<style scoped>
  .expired {
    color: #f56c6c;
    font-weight: 600;
  }
  .expire-soon {
    color: #e6a23c;
    font-weight: 600;
  }
</style>
